import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HorariosService } from 'src/app/services/horarios.service';
import { EspecialidadesService } from 'src/app/services/especialidades.service';
import { PlanosService } from 'src/app/services/planos.service';
import { ConveniosService } from 'src/app/services/convenios.service';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ParametrosService } from 'src/app/services/parametros.service';
import { EmpresasService } from 'src/app/services/empresas.service';
import { EmpresaType } from 'src/app/interfaces/empresa';
import { MatStepper } from '@angular/material';
import { PagamentosService } from 'src/app/services/pagamentos.service';
import { StatusAgendamentoService } from 'src/app/services/status-agendamento.service';

interface EspecialidadeRequestResponseType {
  especialidades: {
    agendaid: number
    tipoagenda: 'am' | 'cs'
    cboid: number
  }[]
}

@Component({
  selector: 'app-convenio-client',
  templateUrl: './convenio-client.component.html',
  styleUrls: ['./convenio-client.component.scss']
})
export class ConvenioClientComponent implements OnInit {
  empresaOptions: EmpresaType[] = []
  empresaSelecionado: EmpresaType | undefined
  requerEmpresa: boolean = false

  myConvenioControl = new FormControl();
  convenioOptions: any = {};
  filteredConvenioOptions: Observable<any[]>;
  convenioSelecionado: any;

  myPlanoControl = new FormControl();
  planoOptions: any = {};
  planosConvenio: any = [];
  filteredPlanoOptions: Observable<any[]>;
  planoSelecionado: any = {};

  myEspecialidadeControl = new FormControl();
  originalEspecialidadeOptions: any[] = [];
  especialidadeOptions: any = {};
  especialidadesAgendas: any = [];
  filteredEspecialidadeOptions: Observable<any[]>;
  especialidadeSelecionada: any;

  carteirinhaNumero = new FormControl()

  startMessage: string;

  isExec = false;

  smallScreen: boolean;
  @Input() stepper: any;
  @Input() tipo: number;
  sessionData: any = {};
  @Output() carregarHorarios = new EventEmitter<any>();
  @Output() carregarProcedimentos = new EventEmitter<any>();
  @Output() validarCamposConvenio = new EventEmitter<boolean>();
  @Input() servicos: any;
  @Input() agendas: any;
  @Input() tipoAgendamento: string;

  especialidadeHint: string;
  
  carteirinhaAnexoPreviewDataURL: string = ''
  parametroObrigarCarteirinhaAnexo: boolean = false
  parametroObrigarCarteirinhaValidade: boolean = false
  parametroValidarCarteirinhaValidade: boolean = false

  hideCompanyField: boolean = false

  constructor(
    private especialidadesService: EspecialidadesService,
    private conveniosService: ConveniosService,
    private horariosService: HorariosService,
    private planosService: PlanosService,
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private parametrosService: ParametrosService,
    private empresasService: EmpresasService,
    private paymentService: PagamentosService,
    private schedulingStatus: StatusAgendamentoService
  ) {
    this.authService.userLoggedOut.subscribe(userLoggedOut => {

      // Se usuário fez logout usando ícone no menu na barra, atualiza
      if (userLoggedOut) {
        this.myConvenioControl.reset();
        this.myPlanoControl.reset();
        this.myEspecialidadeControl.reset();

        this.myConvenioControl.setErrors(null);
        this.myPlanoControl.setErrors(null);
        this.myEspecialidadeControl.setErrors(null);

        this.setFormControls();

        this.convenioSelecionado = null;
        this.planoSelecionado = null;
        this.especialidadeSelecionada = null;
      }
      this.smallScreen = (window.innerWidth <= 400) ? true : false;
      breakpointObserver.observe([
        Breakpoints.XSmall,
        Breakpoints.Small
      ]).subscribe(result => {
        this.smallScreen = result.matches;
      });
    });

    const alertLoad: any = parametrosService.getParams('APP_START_ALERT');
    this.startMessage = alertLoad && alertLoad.valor ? alertLoad.valor : '';

  }

  ngOnInit() {
    this.schedulingStatus.paidWithPix = false
    this.setFormControls();
    this.myPlanoControl.disable();
    this.myEspecialidadeControl.disable();

    this.empresasService.getEmpresas().subscribe((res: { empresas: EmpresaType[] }) => {
      this.empresaOptions = res.empresas.filter((empresa) => {
        // verify if the enterprise has associations with schedules  
        if (empresa.associated_ag) {
            const parsedAgAssociations = JSON.parse(empresa.associated_ag)
            if (parsedAgAssociations.length > 0) {
              return true
            }
          }

          if (empresa.associated_cs) {
            const parsedCsAssociations = JSON.parse(empresa.associated_cs)
            if (parsedCsAssociations.length > 0) {
              return true
            }
          }
      })
      this.requerEmpresa = Boolean(this.empresaOptions.length > 1)

      if (this.empresaOptions.length === 1) {
        this.empresaSelecionado = this.empresaOptions[0]

        this.especialidadesService.postConsultaEspecialidades(this.empresaSelecionado.id).subscribe((res: EspecialidadeRequestResponseType) => {
          const ids: number[] = []
          for (const especialidade of res.especialidades)
            ids.push(especialidade.cboid)

          this.especialidadeOptions = this.originalEspecialidadeOptions
          this.especialidadeOptions = this.especialidadeOptions.filter((option: any) => ids.includes(option.integracao_id))
          this.listaEspecialidadesAgendas();
        })
      }
    })

    const hideCompanyFieldLoad = this.parametrosService.getParams('HIDE_COMPANY') || { valor: 'false' }
    this.hideCompanyField = hideCompanyFieldLoad.valor === 'true'
  }

  checkIfPixPaymentRunning () {
    this.updateSessionData()
    if(!this.sessionData.selecaoObj) return
    const paymentInfo = sessionStorage.getItem('pixPayment')
    const healthInsuranceId = this.sessionData.selecaoObj.convenio.integracao_id
    
    if(!paymentInfo || !healthInsuranceId) return

    const jsonPayment = JSON.parse(paymentInfo)
    const leftTime = this.paymentService.getStoredLeftTime(jsonPayment.time_left, jsonPayment.destroyed_at)

    this.paymentService.getCharge(jsonPayment.charge_id).subscribe((resp: any) => {
      if(!resp.paymentDate && leftTime < 0) {
        this.paymentService.deleteCharge(jsonPayment.charge_id).subscribe(() => {
          sessionStorage.removeItem('pixPayment')
        })
        return
      }
      if(resp.paymentDate) {
        this.schedulingStatus.paidWithPix = true
        this.schedulingStatus.infoPagamento = {
          id: jsonPayment.charge_id,
          value: Number(parseFloat(this.sessionData.horarioSel.valor)),
          paidWithPix: true
        }
      }
      this.convenioSelecionado = {
        integracao_id: healthInsuranceId
      }
      this.checkPagamentoCaixa()
  
      const index = JSON.parse(paymentInfo).step_index

      this.stepper.linear = false
      setTimeout(() => {
        if(this.stepper._steps._results[index].label !== 'stepPagamento') return
        this.stepper.selectedIndex = resp.paymentDate ? this.stepper._stepHeader.length - 1 : index
        this.stepper.linear = true
      }, 500)
    })
  }

  setFormControls() {
    this.conveniosService.consultaConvenios()
      .subscribe((data: any) => {
        this.checkIfPixPaymentRunning()
        this.convenioOptions = []
        data.forEach(element => {
          if (element.status === true) {
            this.convenioOptions.push(element);
          }
        });
        // this.convenioOptions = data;
        this.convenioOptions.sort((a: any, b: any) => {
          if (a.descricao < b.descricao) {
            return -1;
          }
          if (a.descricao > b.descricao) {
            return 1;
          }
          return 0;
        });
        this.filteredConvenioOptions = this.myConvenioControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterConvenio(value))
          );
      });

    this.planosService.consultaPlanos()
      .subscribe((data: any) => {
        this.planoOptions = []
        data.forEach(element => {
          if (element.status === true) {
            this.planoOptions.push(element);
          }
        });
        this.listaPlanosDoConvenio();
      });

    this.especialidadesService.consultaEspecialidades()
      .subscribe((data: any) => {
        this.especialidadeOptions = [];
        data.forEach(element => {
          if (element.status === true) {
            this.especialidadeOptions.push(element);
          }
        });
        this.originalEspecialidadeOptions = this.especialidadeOptions
        this.listaEspecialidadesAgendas();
      });
  }

  private _filterConvenio(value: string): string[] {

    const filterValue = value && value.toLowerCase();
    return this.convenioOptions.filter(option => option.descricao.toLowerCase().includes(filterValue));
  }

  private _filterPlano(value: string): string[] {
    const filterValue = value && value.toLowerCase();

    return this.planosConvenio.filter(option => option.descricao.toLowerCase().includes(filterValue));
  }

  private _filterEspecialidade(value: string): string[] {
    const filterValue = value && value.toLowerCase();

    return this.especialidadesAgendas.filter(option => option.descricao.toLowerCase().includes(filterValue));
  }

  onEmpresaBlur() {
    if (this.requerEmpresa && (this.empresaSelecionado || this.hideCompanyField) && this.convenioSelecionado) {
      this.myPlanoControl.enable()
      this.myEspecialidadeControl.enable()
    } else {
      this.myPlanoControl.disable()
      this.myEspecialidadeControl.disable()
    }

    if (this.convenioSelecionado) {
      this.convenioSelecionado = undefined
      this.myConvenioControl.setValue('')
      this.filteredConvenioOptions = this.myConvenioControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filterConvenio(value))
        );
    }

    if (this.requerEmpresa && (this.empresaSelecionado || this.hideCompanyField)) {
      if(!this.hideCompanyField){
        this.especialidadesService.postConsultaEspecialidades(this.empresaSelecionado.id).subscribe((res: EspecialidadeRequestResponseType) => {
          const ids: number[] = []
          for (const especialidade of res.especialidades)
            ids.push(especialidade.cboid)
  
       
          this.especialidadeOptions = this.originalEspecialidadeOptions
          this.especialidadeOptions = this.especialidadeOptions.filter((option: any) => ids.includes(option.integracao_id))
          this.listaEspecialidadesAgendas()
        })
      } else {
        this.especialidadeOptions = this.originalEspecialidadeOptions
        this.listaEspecialidadesAgendas()
      }
    }
  }

  onConvenioBlur() {
    if (this.myConvenioControl.value) {
      this.myConvenioControl.setValue(this.myConvenioControl.value.trim());
    }
    const { value } = this.myConvenioControl;

    if (value) {
      this.convenioSelecionado = this.convenioOptions.find(
        item => item.descricao.toLowerCase() === value.toLowerCase()
      );
    }

    if (!this.convenioSelecionado) {
      this.myConvenioControl.setErrors({ incorrect: true });
      this.myPlanoControl.disable();
      this.myEspecialidadeControl.disable();
    } else {
      this.myPlanoControl.enable();
      this.myEspecialidadeControl.enable();
      this.checkPagamentoCaixa();
    }
    if (this.requerEmpresa && (this.empresaSelecionado || this.hideCompanyField) && this.convenioSelecionado) {
      this.myPlanoControl.enable()
      this.myEspecialidadeControl.enable()
    } else if (this.requerEmpresa) {
      this.myPlanoControl.disable()
      this.myEspecialidadeControl.disable()
    }
    if (this.convenioSelecionado) {
      this.listaPlanosDoConvenio();
      this.listaEspecialidadesAgendas();
      this.completeStepper();
    }
  }

  onPlanoBlur() {
    if (this.myPlanoControl.value) {
      this.myPlanoControl.setValue(this.myPlanoControl.value.trim());
    }
    const { value } = this.myPlanoControl;

    if (value) {
      this.planoSelecionado = this.planoOptions.find(
        item => item.descricao.toLowerCase() === value.toLowerCase()
      );
    }

    if (!this.planoSelecionado) {
      this.myPlanoControl.setErrors({ incorrect: true });
    }
    this.completeStepper();
  }

  onEspecialidadeBlur() {
    if (this.myEspecialidadeControl.value) {
      this.myEspecialidadeControl.setValue(this.myEspecialidadeControl.value.trim());
    }
    const { value } = this.myEspecialidadeControl;

    if (value) {
      this.especialidadeSelecionada = this.especialidadeOptions.find(
        item => item.descricao.toLowerCase() === value.toLowerCase()
      );
    }

    if (!this.especialidadeSelecionada) {
      this.myEspecialidadeControl.setErrors({ incorrect: true });
    }
    this.completeStepper();
  }

  checkPagamentoCaixa() {
    const pagamentoCaixa = this.conveniosService.checkPagamentoCaixa(this.convenioSelecionado.integracao_id);
    this.convenioSelecionado.webpagcaixa = pagamentoCaixa
  }

  onCarteirinhaInput () {
    this.convenioSelecionado.carteirinha = this.carteirinhaNumero.value
  }

  listaPlanosDoConvenio() {
    this.planosConvenio = [];
    if (this.convenioSelecionado) {
      if (this.planoSelecionado.convenio_id !== this.convenioSelecionado.id) {
        this.planoSelecionado = {};
        this.myPlanoControl.reset();
      }
      this.planoOptions.forEach(element => {
        if (element.convenio_id === this.convenioSelecionado.id) {
          this.planosConvenio.push(element);
        }
      });
      this.planosConvenio.sort((a, b) => {
        if (a.descricao < b.descricao) {
          return -1;
        }
        if (a.descricao > b.descricao) {
          return 1;
        }
        return 0;
      });
      this.filteredPlanoOptions = this.myPlanoControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filterPlano(value))
        );
    }
  }

  listaEspecialidadesAgendas() {
    this.especialidadesAgendas = [];
    if (this.convenioSelecionado) {
      if (!this.especialidadesAgendas.find((find: any) => find.id !== this.especialidadeSelecionada.id)) {
        this.especialidadeSelecionada = {};
        this.myEspecialidadeControl.reset();
      }
      for (let i = 0; i < (this.agendas.length); i++) { // Percorrer as agendas
        const ag = this.agendas[i];
        const achou: any = ag.convenios && ag.convenios.find(
          (conv: any) => conv.id === this.convenioSelecionado.id
        );

        if (achou) {
          if (ag.especialidades) {
            ag.especialidades.forEach((espec: any) => { // Percorre as especialidades
              const jaexiste = this.especialidadesAgendas.find((esp: any) => esp.id === espec);
              if (!jaexiste) {
                const newItem = this.especialidadeOptions.findIndex(
                  (esp: any) => esp.id === espec
                );
                if (this.especialidadeOptions[newItem])
                  this.especialidadesAgendas.push(this.especialidadeOptions[newItem]);
              }
            });
          }
        }
      }

      this.especialidadesAgendas.sort((a, b) => {
        if (a.descricao < b.descricao) {
          return -1;
        }
        if (a.descricao > b.descricao) {
          return 1;
        }
        return 0;
      });

      this.filteredEspecialidadeOptions = this.myEspecialidadeControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filterEspecialidade(value))
        );
      if (this.especialidadesAgendas.length) {
        this.especialidadeHint = '';
      } else {
        this.especialidadeHint = 'vazio';
      }
    } else {
      this.especialidadeSelecionada = {};
      this.myEspecialidadeControl.reset();
      this.myEspecialidadeControl.disable();
    }
  }

  onClickEspecialidade() {
    if (this.myEspecialidadeControl.disabled && !this.convenioSelecionado) {
      this.especialidadeHint = 'sem_convenio';
    }
  }

  isFormValid() {
    let valido = true;
    if (this.myConvenioControl.status !== 'VALID') {
      valido = false;
    }
    if ((this.myPlanoControl.status !== 'VALID' && this.planosConvenio.length > 0)) {
      valido = false;
    }
    if (this.myEspecialidadeControl.status !== 'VALID') {
      valido = false;
    }
    if (this.isExec === true) {
      valido = false;
    }
    if (this.requerEmpresa && !(this.empresaSelecionado || this.hideCompanyField)) {
      valido = false;
    }
    if (this.parametroObrigarCarteirinhaAnexo) {
      if (!this.conveniosService.anexoCarteirinha) {
        valido = false
      }
    }

    if(this.parametroObrigarCarteirinhaValidade) {
      const carteirinhaValue = this.carteirinhaNumero.value
      if(!Number(carteirinhaValue) || carteirinhaValue.toString().length < 7) {
        valido = false
      }
    }
    return valido;
  }

  selectedOn(event, convenio) {
    if (event.isUserInput === true || event.source._selected === true) {
      this.planosConvenio = [];
      if (this.planoSelecionado.convenio_id !== convenio.id) {
        this.planoSelecionado = {};
        this.myPlanoControl.reset();
      }
      this.planoOptions.forEach((element: any) => {
        if (element.convenio_id === convenio.id) {
          this.planosConvenio.push(element);
        }
        this.filteredPlanoOptions = this.myPlanoControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterPlano(value))
          );
      });

      this.parametrosService.getConvenioParams(convenio.integracao_id).subscribe({
        next: (value) => {
          this.parametroObrigarCarteirinhaAnexo = Boolean(value.data.CatPlanoParametrosWEBObrigarCartAnexo)
          this.parametroObrigarCarteirinhaValidade = Boolean(value.data.CatPlanoParametrosWEBObrigarCartValidade)
          this.parametroValidarCarteirinhaValidade = Boolean(value.data.CatPlanoParametrosWEBValidarCartValidade)
          this.conveniosService.convenioParametros = {}
          this.conveniosService.convenioParametros.parametroObrigarCarteirinhaAnexo = this.parametroObrigarCarteirinhaAnexo
          this.conveniosService.convenioParametros.parametroObrigarCarteirinhaValidade = this.parametroObrigarCarteirinhaValidade
          this.conveniosService.convenioParametros.parametroValidarCarteirinhaValidade = this.parametroValidarCarteirinhaValidade
          this.carteirinhaAnexoPreviewDataURL = ''
          this.conveniosService.anexoCarteirinha = undefined
          this.conveniosService.validadeCarteirinha = ''
        },
        error: () => {}
      })
    }
  }

  completeStepper() {
    if (this.myConvenioControl.status === 'VALID'
      && (
        (this.myPlanoControl.status === 'VALID' && this.planosConvenio.length > 0)
        || (this.planosConvenio.length === 0)
      )
      && this.myEspecialidadeControl.status === 'VALID') {
      this.validarCamposConvenio.emit(true);
    } else {
      this.validarCamposConvenio.emit(false);
    }
  }

  validaConvenioEspec() {

    const user = this.authService.getUser()
    if (user) {
      this.checkUserClinicaELO()
    } else {
      this.validNextStep()
    }

  }

  private checkUserClinicaELO() {
    
    const user = this.authService.getUser()

    const param = this.conveniosService.findConvenioParametros(this.convenioSelecionado.integracao_id, this.planoSelecionado.integracao_id)
    if (param && param.hasOwnProperty('CategoriaPlanoParametrosIntegr') && param.CategoriaPlanoParametrosIntegr && param.CategoriaPlanoParametrosIntegr === 3) {
      this.isExec = true
      this.conveniosService.checkEloCPF(user.cpf)
        .subscribe(resp => {
          if (resp && resp.codigo === 1) {
            this.validNextStep()
          } else {
            alert('Paciente não credenciado para o convênio')
          }
          this.isExec = false
        })
    } else {
      this.validNextStep()
    }

  }

  private validNextStep() {
    this.updateSessionData();
    if (this.myConvenioControl.status === 'VALID' &&
      ((this.myPlanoControl.status === 'VALID' && this.planosConvenio.length > 0) || (this.planosConvenio.length === 0)) &&
      this.myEspecialidadeControl.status === 'VALID') {
      this.validarCamposConvenio.emit(true);
      if (this.tipoAgendamento === 'CONSULTA') {
        this.carregarHorarios.emit();
      } else {
        this.carregarProcedimentos.emit();
      }
      this.stepper.next();
    } else {
      this.validarCamposConvenio.emit(false);
      this.myConvenioControl.markAsTouched({ onlySelf: true });
      this.myPlanoControl.markAsTouched({ onlySelf: true });
      this.myEspecialidadeControl.markAsTouched({ onlySelf: true });
    }
  }

  updateSessionData() {
    const userData = sessionStorage.getItem('userData');
    const selecaoObj = sessionStorage.getItem('selecaoObj');
    const horarioSel = sessionStorage.getItem('horarioSel');

    this.sessionData = {
      userData: JSON.parse(userData),
      selecaoObj: JSON.parse(selecaoObj),
      horarioSel: JSON.parse(horarioSel)
    };
  }

  onCarteirinhaAnexo(event: Event) {
    const target = event.target as HTMLInputElement

    if (!target.files) return
    if (!target.files.length) return

    const file = target.files[0]
    this.conveniosService.anexoCarteirinha = file

    const reader = new FileReader()
    reader.onload = (e: Event) => {
      const readerTarget = e.target as FileReader
      this.carteirinhaAnexoPreviewDataURL = readerTarget.result.toString()
    }

    reader.readAsDataURL(file)
  }

  onCarteirinhaValidade(event: Event) {
    const target = event.target as HTMLInputElement
    this.conveniosService.validadeCarteirinha = target.value
  }

  getTodayDate() {
    return new Date().toISOString().split('T')[0]
  }

  onVoltarClick() {
    this.stepper.previous();
  }
}
